import * as $ajax from './_ajax'
import * as $form from './_form'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $common from './owner.notes.common'

var optionDefaults = {
    agareId: 0,
    pageName: null,
    pagePrefix: null,
    onListChanged: null,
    showInModal: null,
}

var options: any
var filter: string = null
var agareId: number = 0
var rootElement: JQuery = null
var textElem: JQuery = null
var dateElem: JQuery = null
var visElem: JQuery = null

export function init($options): void {
    options = $.extend(true, {}, optionDefaults, $options)

    agareId =
        $('.' + options.pagePrefix + '-agareid').length > 0
            ? $('.' + options.pagePrefix + '-agareid').val()
            : options.agareId
    rootElement = $('.' + options.pageName)
    textElem = $('.' + options.pagePrefix + '-text')
    dateElem = $('.' + options.pagePrefix + '-aterkomstdatum')
    visElem = $('.' + options.pagePrefix + '-visibility')

    if (rootElement && rootElement.length > 0) {
        rootElement
            .find('.' + options.pagePrefix + '-no-' + options.agareId)
            .html(rootElement.find('.' + options.pagePrefix + '-listitem').length.toString())

        rootElement.find('.' + options.pagePrefix + '-listitem-footer-icons .glyphicon-pencil').click(function () {
            editNote($(this).attr('data-id'))
        })

        rootElement.find('.' + options.pagePrefix + '-listitem-footer-icons .glyphicon-ok').click(function () {
            toggleCompleted($(this).attr('data-id'))
        })

        rootElement.find('.' + options.pagePrefix + '-listitem-footer-icons .glyphicon-remove').click(function () {
            deleteNote($(this).attr('data-id'))
        })

        rootElement.find('.' + options.pagePrefix + '-btn-create').click(function () {
            createNote()
        })

        rootElement.find('.' + options.pagePrefix + '-btn-close').click(function () {
            $modal.hide()
        })

        // since the notes action is always loaded async, this always needs to run
        $helpers.partialPageInit(rootElement)
    }
}

function editNote(id: string): void {
    $modal.load('/Note/EditOwner', { id, callback: 'bcfla.owner.notes.list.getNotes' }, false)
}

export function toggleCompleted(id: string, reloadList: boolean = true): void {
    $common.toggleCompleted(id, reloadList ? getNotes : null)
}

function deleteNote(id: string): void {
    $common.deleteNote(id, getNotes)
}

export function createNote(): void {
    $common.createNote(
        agareId.toString(),
        textElem.val(),
        dateElem.val(),
        $form.getCheckboxlistValues(visElem)?.[0] || '1',
        getNotes
    )
}

export function getNotes(): void {
    $ajax.post({
        loadingText: 'Hämtar noteringar...',
        url: '/Owner/NotesList',
        data: {
            ownerId: agareId,
            showInModal: options.showInModal,
        },
        dataType: 'html',
        success: function (res: string) {
            if (!$ajax.okResponseHtml(res)) return

            if (options.showInModal) {
                $modal.show(res, false)
            } else {
                rootElement.parent().html(res)
                $helpers.partialPageInit(rootElement.parent())
            }
            if (filter !== null)
                filterList(<HTMLSpanElement>rootElement.find('.' + options.pagePrefix + '-filter-' + filter)[0], filter)
            if (options.onListChanged) options.onListChanged()
        },
    })
}

export function filterList(clickedLabel: HTMLSpanElement, filterToSet: string): void {
    var classesToHide = 'blockquote'

    switch (filterToSet) {
        case 'open':
            classesToHide = `.${options.pagePrefix}-listitem-complete,.${options.pagePrefix}-listitem-note`
            break
        case 'expired':
            classesToHide = `.${options.pagePrefix}-listitem-complete,.${options.pagePrefix}-listitem-note,.${options.pagePrefix}-listitem-open`
            break
        case 'complete':
            classesToHide = `.${options.pagePrefix}-listitem-expired,.${options.pagePrefix}-listitem-note,.${options.pagePrefix}-listitem-open`
            break
        case 'notes':
            classesToHide = `.${options.pagePrefix}-listitem-complete,.${options.pagePrefix}-listitem-expired,.${options.pagePrefix}-listitem-open`
            break
        case 'private':
            classesToHide = `.${options.pagePrefix}-listitem-public`
            break
    }

    $('.' + options.pagePrefix + '-filter .bcfla-label').addClass('bcfla-label-unchecked')
    $(clickedLabel).removeClass('bcfla-label-unchecked')

    rootElement.find('.' + options.pagePrefix + '-listitem').show()
    rootElement.find(classesToHide).hide()

    if (rootElement.find('.' + options.pagePrefix + '-listitem:visible').length === 0) {
        rootElement.find('.' + options.pagePrefix + '-listitem').show()
        rootElement.find('.' + options.pagePrefix + '-filter .bcfla-label').addClass('bcfla-label-unchecked')
        rootElement
            .find('.' + options.pagePrefix + '-filter .' + options.pagePrefix + '-filter-all')
            .removeClass('bcfla-label-unchecked')
    }

    filter = filterToSet

    if (options.onListChanged) options.onListChanged()
}
